<template>
  <div :class="$attrs.class">
      <p class="lg:text-3xl text-2xl font-thin"> You are the </p>
      <b class="lg:text-6xl text-5xl"> {{$attrs.result}} </b>
  </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style>

</style>